export { default as DeleteDialog } from './DeleteDialog';
